// extracted by mini-css-extract-plugin
export default {"avatar":"BurgerMenu_avatar__M7zUJ","withImg":"BurgerMenu_withImg__JKCe5","notification":"BurgerMenu_notification__rjKJe"};